import React from 'react';
import { Divider } from '@mui/material';

export function ToolbarVerticalDivider() {
  return <Divider orientation="vertical" variant="middle" flexItem sx={{ marginX: 1 }} />;
}
